import React, { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { ApplicationContext } from 'App/context'
import { push } from 'connected-react-router'
import actions from '../../../common/redux/initial/actions'

import userManager, { CallbackComponent, User } from 'App/util/UserManager'
import Loader from 'App/components/Loader'

const HootsuiteContentSourceCallbackPage = () => {
  const ctx = useContext(ApplicationContext)
  const dispatch = useDispatch()

  const successCallback = async (user: User) => {
    if (ctx.extraQueryParams === undefined) {
      ctx.extraQueryParams = {}
    }
    if (ctx.extraTokenParams === undefined) {
      ctx.extraTokenParams = {}
    }
    ctx.extraQueryParams.hootsuiteUserId  = window.sessionStorage.getItem('hootsuiteUserId')
    ctx.extraQueryParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp')
    ctx.extraQueryParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId')
    ctx.extraQueryParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken')
    ctx.extraQueryParams.messageId = window.sessionStorage.getItem('messageId')
    ctx.extraTokenParams.hootsuiteUserId = window.sessionStorage.getItem('hootsuiteUserId')
    ctx.extraTokenParams.hootsuiteTimestamp = window.sessionStorage.getItem('hootsuiteTimestamp')
    ctx.extraTokenParams.hootsuitePlacementId = window.sessionStorage.getItem('hootsuitePlacementId')
    ctx.extraTokenParams.hootsuiteToken = window.sessionStorage.getItem('hootsuiteToken')
    ctx.extraTokenParams.messageId = window.sessionStorage.getItem('messageId')
    window.sessionStorage.removeItem('hootsuiteUserId')
    window.sessionStorage.removeItem('hootsuiteTimestamp')
    window.sessionStorage.removeItem('hootsuitePlacementId')
    window.sessionStorage.removeItem('hootsuiteToken')
    window.sessionStorage.removeItem('messageId')
    dispatch({
      type: actions.LOAD_DATA,
      payload: {
        user: user,
      },
    })

    dispatch(push('/'))
  }

  const errorCallback = (error: Error) => {
    dispatch(push('/'))
    console.error('an error occured in callback', error)
  }

  return (
    <CallbackComponent
      errorCallback={errorCallback}
      successCallback={successCallback}
      userManager={userManager}
    >
      <Loader />
    </CallbackComponent>
  )
}

export default {
  name: 'HootsuiteContentSourceCallback',
  routeProps: {
    path: '/callback',
    component: HootsuiteContentSourceCallbackPage,
  },
}
